<template>
  <Transition name="banner">
    <div v-if="isVisible" class="cookie-banner">
      <p class="cookie-message">
        {{ $t('base.cookieConsent.message') }}

        <a
          href="https://cdn.catalina-software.co.uk/PrivacyPolicy/FreedomGoX"
          target="_blank"
        >
          {{ $t('base.cookieConsent.privacyPolicy') }}
        </a>
      </p>
      <div class="flex flex-col gap-2">
        <ion-button
          class="pill-button"
          size="small"
          color="success"
          @click="accept"
        >
          {{ $t('base.cookieConsent.accept') }}
        </ion-button>
        <ion-button
          class="pill-button"
          size="small"
          fill="outline"
          @click="dismiss"
        >
          {{ $t('base.cookieConsent.dismiss') }}
        </ion-button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { IonButton } from '@ionic/vue';
import { useStore } from '../store';
import { Capacitor } from '@capacitor/core';

const store = useStore();
const dismissedThisSession = ref(false);

const isVisible = computed(
  () =>
    !Capacitor.isNativePlatform() &&
    !store.cookieConsent &&
    !dismissedThisSession.value,
);

const accept = () => {
  store.cookieConsent = true;
};

const dismiss = () => {
  dismissedThisSession.value = true;
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px max(16px, calc((100% - 960px) / 2));
  padding-bottom: calc(12px + var(--ion-safe-area-bottom));
  background: var(--ion-item-background);
  border-top: 1px solid var(--app-border-subtle);
  box-shadow: 0 -4px 16px rgba(var(--app-shadow-rgb), 0.08);
}

.cookie-message {
  flex: 1;
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: var(--app-text-secondary);
}

.banner-enter-active,
.banner-leave-active {
  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}

.banner-enter-from,
.banner-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
